import { useMsal } from "@azure/msal-react";
import { Button } from "../Button/Button";
import styles from "./HeadLog.module.scss";
import { loginRequest, useDxp } from "../../authConfig";
import { isPWAInstalled } from "../../utils";
import { setShowAccessKey } from "../../features/counter/counterSlice";
import { useDispatch } from "react-redux";
import { openLoginModal } from "../../features/search/util";

export const HeadLog = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const handleLoginClick = () => { 
    if (useDxp) {
      if (isPWAInstalled()) {
        instance.loginRedirect(loginRequest).catch((e) => {
          console.error(e);
        });
      } else {
        instance.loginPopup(loginRequest).catch((e) => {
          console.error(e);
        });
      }
    } else {
      dispatch(setShowAccessKey(false));
      openLoginModal();
    }
  };
  return (
    <div className={`container ${styles.container}`}>
      <Button bgColor="black">Subscribe</Button>
      <Button onClick={handleLoginClick}>Log in</Button>
    </div>
  );
};
